// RemixModal Component
// Displays confirmation modal for remixing an app

import React from 'react';
import { RevoltModal, RevoltButton, RevoltIcon, RevoltMagicButton } from './';
import './RemixModal.css';

export function RemixModal({
  isOpen,
  onClose,
  onConfirmRemix,
  project,
  isLoading = false,
  errorMessage = null
}) {
  if (!project) return null;

  // Format the actual app size
  const formatBytes = (bytes) => {
    if (bytes === 0) return "0 B";
    const k = 1024;
    const sizes = ["B", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
  };

  const fileSizeDisplay = project.totalSizeBytes
    ? formatBytes(project.totalSizeBytes)
    : "Unknown"; // Placeholder value

  const handleConfirm = () => {
    if (onConfirmRemix) {
      onConfirmRemix(project);
    }
  };

  return (
    <RevoltModal
      isOpen={isOpen}
      onClose={onClose}
      title={
        <>
          <RevoltIcon name="lucide:wand-sparkles" size="lg" />
          <span className="remix-modal-title-text">Remix</span>
        </>
      }
      containerClassName="remix-modal"
      showCloseButton={false}
    >
      <div className="remix-modal-content">
        <h3 className="remix-modal-app-title">{project.name}</h3>
        <p className="remix-modal-app-owner">
          Owned by <strong>{project.ownerName || project.ownerDisplayName || project.ownerUsername || 'Unknown'}</strong>
        </p>
        <p className="remix-modal-app-size">
          Size: <strong>{fileSizeDisplay}</strong>
        </p>

        {errorMessage && (
          <p className="remix-modal-error" role="alert">
            {errorMessage}
          </p>
        )}

        <div className="remix-modal-actions">
          <RevoltButton variant="outline" onClick={onClose} disabled={isLoading}>
            Cancel
          </RevoltButton>
          <RevoltMagicButton variant="accent" onClick={handleConfirm} disabled={isLoading}>
            {isLoading ? (
              <>
                <i className="fa-solid fa-spinner fa-spin"></i>
                Remixing...
              </>
            ) : (
              <>
                <RevoltIcon name="lucide:wand-sparkles" />
                Remix
              </>
            )}
          </RevoltMagicButton>
        </div>
      </div>
    </RevoltModal>
  );
}